import { useEffect, useState } from 'react';

export default function useTabVisibility() {
  const [isVisible, setIsVisible] = useState(
    () => !document.hidden && document.hasFocus(),
  );

  useEffect(() => {
    const handleVisibilityChange = () => {
      const newVisible = !document.hidden && document.hasFocus();
      setIsVisible(newVisible);
    };

    window.addEventListener('focus', handleVisibilityChange);
    window.addEventListener('blur', handleVisibilityChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', handleVisibilityChange);
      window.removeEventListener('focus', handleVisibilityChange);
    };
  }, []);

  return isVisible;
}
